export function clearProgress(){
    return {
        type: 'PROGRESS_CLEAR',
    }
}